import { Box, Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useProduct } from '@/context/product'
import { clearStoragePreservingAnnouncements } from '@/helpers'
import { routes } from '@/router'

export function ViewAsBanner() {
  const navigate = useNavigate()
  const { companies, personName, selectedCompanyKey } = useProduct()

  const companyName = companies.find(
    (company) => company.company_key === selectedCompanyKey,
  )?.corporate_name

  const subject = companyName || personName

  const endSession = () => {
    clearStoragePreservingAnnouncements()
    navigate(routes.session.signin)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        px: 2,
        py: 0.75,
        bgcolor: 'warning.main',
        color: 'warning.contrastText',
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        Acessando como operador{subject ? ` · ${subject}` : ''}
      </Typography>
      <Button
        size="small"
        variant="outlined"
        onClick={endSession}
        sx={{
          color: 'inherit',
          borderColor: 'currentColor',
          flexShrink: 0,
        }}
      >
        Encerrar
      </Button>
    </Box>
  )
}
